import React from 'react'
import { Box, Button, IconButton } from '@mui/material'
import { GridToolbarContainer } from '@mui/x-data-grid'
import PropTypes from 'prop-types'

import { Search } from '../../../assets/icons/circles/Search'
import CustomSearchbar from '../../../common/AbstractDataGrid/CustomSearchbar'
import MUIDataGrid from '../../../common/AbstractDataGrid/DataGridMUI'
import TableSkeleton from '../../../common/Skeletons/TableSkeleton'
import chips from '../../../common/ui/chips'
import { ColorBoxContent } from '../../../common/ui/colorBox'
import { formatDateToLocale } from '../../../helpers/date'

const unreadHighlight = (ticket, currUser) => {
  const newTicketCondition = ticket.isNewTicket && ticket.userId !== currUser
  const newReplyCondition =
    ticket.replies.length > 0 &&
    ticket.replies[ticket.replies.length - 1].authorId !== currUser
  if (
    ticket.status !== 'Resolved' &&
    (newTicketCondition || newReplyCondition)
  ) {
    return true
  }
}

export default function SupportTickets({
  tickets,
  role,
  setPage,
  currUser,
  retrieveTicketsStatus,
  toggleDrawer,
  setTicketDetails
}) {
  const rows = tickets.map((ticket) => {
    return {
      id: ticket._id,
      orgId: ticket.orgInfo.orgId,
      orgName: ticket.orgInfo.orgName,
      userId: ticket.clientInfo.userId,
      userName: ticket.clientInfo.userName,
      userEmail: ticket.clientInfo.userEmail,
      ticketNo: ticket.ticketNo,
      subject: ticket.subject,
      message: ticket.message,
      replies: ticket.replies,
      status: ticket.status,
      createdAt: ticket.createdAt,
      closedAt: ticket.closedAt,
      firstResponseAt: ticket.firstResponseAt,
      isNewTicket: ticket.isNewTicket,
      lastReplyAt:
        ticket.lastReplyAt === undefined
          ? '-'
          : formatDateToLocale(ticket.lastReplyAt)
    }
  })

  const columns = [
    { field: 'createdAt', headerName: 'Date Received', width: 100 },
    { field: 'ticketNo', headerName: 'Ticket', width: 100 },
    { field: 'subject', headerName: 'Subject', width: 100 },
    { field: 'lastReplyAt', headerName: 'Last Reply', width: 100 },
    { field: 'orgName', headerName: 'Company', width: 100 },
    {
      field: 'status',
      headerName: 'Status',
      width: 50,
      renderCell: (params) => {
        const ticket = params.row
        return (
          <div data-cy='ticketStatus'>
            {chips.support[ticket.status.toUpperCase()]}
          </div>
        )
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 50,
      renderCell: (params) => {
        const ticket = params.row
        return (
          <IconButton
            onClick={(e) => {
              setTicketDetails(ticket)
              toggleDrawer('right', true)(e)
            }}
            data-cy='actionBtn'
          >
            <Search />
          </IconButton>
        )
      }
    }
  ]

  const AccountToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <CustomSearchbar />

        <div id='customerSupport__addNewBtn'>
          <Button
            variant='filled'
            size='small'
            onClick={() => setPage(1)}
            data-cy='createTicketBtn'
          >
            {['opsowner', 'ops'].includes(role)
              ? 'Create Ticket'
              : 'Contact Us'}
          </Button>
        </div>
      </GridToolbarContainer>
    )
  }
  return (
    <>
      <ColorBoxContent style={{ marginTop: 12 }}>
        <Box
          sx={{
            alignItems: 'center',
            mb: '12px'
          }}
        >
          {retrieveTicketsStatus === 'loading' ? (
            <TableSkeleton />
          ) : (
            <div id='customerSupport__dataGrid'>
              <MUIDataGrid
                rows={rows}
                sx={{
                  '.unread-class': {
                    backgroundColor: '#C3C7F7',
                    '&:hover': {
                      backgroundColor: '#C3C7F7'
                    }
                  },
                  '.read-class': {
                    backgroundColor: 'transparent',
                    '&:hover': {
                      backgroundColor: 'transparent'
                    }
                  }
                }}
                getRowClassName={(param) => {
                  const ticket = param.row
                  if (unreadHighlight(ticket, currUser)) {
                    return 'unread-class'
                  }
                  return 'read-class'
                }}
                columns={columns}
                disableSelectionOnClick
                components={{ Toolbar: AccountToolbar }}
              />
            </div>
          )}
        </Box>
      </ColorBoxContent>
    </>
  )
}

SupportTickets.propTypes = {
  tickets: PropTypes.array,
  role: PropTypes.string,
  currUser: PropTypes.string,
  retrieveTicketsStatus: PropTypes.string,
  setPage: PropTypes.func,
  toggleDrawer: PropTypes.func,
  setTicketDetails: PropTypes.func
}
